import { render, staticRenderFns } from "./BankInternalCard.vue?vue&type=template&id=6c7c0140&scoped=true&"
import script from "./BankInternalCard.vue?vue&type=script&lang=js&"
export * from "./BankInternalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7c0140",
  null
  
)

export default component.exports